import { useContext, useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { TextArea } from "../components/common/TextArea";
import { TextBox } from "../components/common/TextBox";
import PopupContent from "../components/popupContent";

import PopupOperationsBar from "./PopupOperationsBar";
import iconBaze from "../images/buttons/baze.png";
import { addNotification } from "../redux/actions";
import { apiGetAllProducts } from "../services/ProductsService";
import { SelectBox } from "../components/common/SelectBox";
import { apiCreateOrUpdateBasis, apiGetBasesDetail } from "../services/BasesService";
import { NumericBox } from "../components/common/NumericBox";
import { model } from "../validation/models/basis";
import { validateForm } from "../validation/formValidation";
import { ValidationProvider } from "../providers/ValidationContext";
import { useTranslation } from "react-i18next";
import TranslationContext from "../providers/TranslationContext";
import { FormatString } from "../helpers/stringHelpers";
// styles
require("./PopupGeneralStyles.css");

interface Props {
  id?: number;
  handleCancel: any;
  refreshData: any;
}

const BasisPopup = (props: Props) => {
  const translationContext = useContext(TranslationContext) as any;
  const prefix = translationContext.prefix;
  const { t } = useTranslation(undefined, { keyPrefix: `${prefix}.Popup` });
  const cloneDeep = require('clone-deep');
  const [validationModel, setValidationModel] = useState(cloneDeep(model));

  const [loadingBasisDetails, setLoadingBasisDetails] = useState(true);
  const [loading, setLoading] = useState(true);
  const [loadingProducts, setLoadingProducts] = useState(true);
  const data: any = {};
  const [formData, setFormData] = useState(data);
  const [saveError, setSaveError] = useState(false);
  const [products, setProducts] = useState([]);
  const dispatch = useDispatch();

  const isEditMode = props.id ? true : false;

  useEffect(() => {
    if (props.id) {
      apiGetBasesDetail(props.id).then((responseData) => {
        setFormData(responseData.data);
        setLoadingBasisDetails(false);
        setLoading(false);
      });
      apiGetAllProducts(false)
        .then((responseData) => {
          let arr = responseData.data.map((element) => {
            return {
              value: element.id,
              label: element.name
            };
          });
          setProducts(arr);
          setLoadingProducts(false);
          setLoading(false);
        });
    } else {
      apiGetAllProducts(false)
        .then((responseData) => {
          let arr = responseData.data.map((element) => {
            return {
              value: element.id,
              label: element.name
            };
          });
          setProducts(arr);
          setLoadingProducts(false);
          setLoading(false);
        });

      setLoading(false);
    }
  }, []);

  const onAddingClick = () => {
    validateForm(validationModel, formData, isEditMode);
    setValidationModel({ ...validationModel });
    if (validationModel.isValid) {
      setLoading(true);
      apiCreateOrUpdateBasis(formData)
        .then((responseData) => {
          dispatch(addNotification({ text: FormatString(t('CreateSuccess'), formData.name, formData.productName), type: 'success' }));
          props.refreshData();
          props.handleCancel();

          setLoading(false);
        })
        .catch((err: any) => {
          dispatch(addNotification({ text: FormatString(t('CreateFailure'), formData.name, formData.productName), type: 'error' }));
          setSaveError(true);
        });
    }
  };

  const onEditingClick = () => {
    validateForm(validationModel, formData, isEditMode);
    setValidationModel({ ...validationModel });
    if (validationModel.isValid) {
      setLoading(true);
      apiCreateOrUpdateBasis(formData)
        .then((responseData) => {

          if (responseData.data.result == true) {
            dispatch(addNotification({ text: FormatString(t('EditSuccess'), formData.name, formData.productName), type: 'success' }));
            props.refreshData();
            props.handleCancel();

            setLoading(false);
          }
          else {
            dispatch(addNotification({ text: FormatString(t('EditFailure'), formData.name, formData.productName), type: 'error' }));
            setSaveError(true);
          }
        })
        .catch((err: any) => {
          dispatch(addNotification({ text: FormatString(t('EditFailure'), formData.name, formData.productName), type: 'error' }));
          setSaveError(true);
        });
    }
  };

  const onCancelClick = () => {
    props.handleCancel();
  };

  return (
    <PopupContent
      headerIcon={iconBaze}
      header={props.id ? t('EditLabel') : t('CreateLabel')}
    >
      <ValidationProvider value={validationModel}>
        <SelectBox
          dataField="productId"
          displayField="productName"
          value={formData.productId}
          formData={formData}
          label={t('Labels.productName')}
          options={products}
          placeholder={t('Labels.productPlaceholder')}
          setStateMethod={setFormData}
          isDisabled={isEditMode}
        />
        <TextBox
          dataField="name"
          defaultValue={formData.name}
          formData={formData}
          setStateMethod={setFormData}
          id="name"
          label={t('Labels.name')}
          placeholder={t('Labels.namePlaceholder')}
        />
        <NumericBox
          dataField="density"
          defaultValue={formData.density}
          formData={formData}
          setStateMethod={setFormData}
          id="density"
          label={t('Labels.density')}
          decimalPlaces={4}
        />
        <TextArea
          id="noteInternal"
          label={t('Labels.noteInternal')}
          placeholder={t('Labels.noteInternalPlaceholder')}
          rows={4}
          dataField="noteInternal"
          formData={formData}
          setStateMethod={setFormData}
          value={formData.noteInternal}
        />

        <PopupOperationsBar
          handleAdding={onAddingClick}
          handleCancellation={onCancelClick}
          handleEditing={onEditingClick}
          id={props.id}
        />
      </ValidationProvider>
    </PopupContent>
  );
};

export default BasisPopup;

